import React from 'react';
import EditableTable from '../../components/EditableTable';
import { TextField } from '@mui/material';
import DateTimeField from '../../components/DateTimeField';
import { toLocalDateTimeString } from '../../utils/dateUtils'; // Import utility function

export default function TreatmentsTable({ treatments, onTreatmentsChange }) {
    const headers = ['Tiempo', 'Notas', 'Peso'];

    const cellTemplates = {
        time: {
            read: (value) => toLocalDateTimeString(value), // Use utility function
            edit: (value, onChange) => (
                <DateTimeField

                    name="time"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        notes: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
        weight: {
            read: (value) => value || '',
            edit: (value, onChange) => (
                <TextField
                    variant="standard"
                    type="number"
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            ),
        },
    };

    const getNewRow = () => {
        const utcTime = new Date().toISOString();
        return {
            id: 0,
            time: utcTime,
            notes: '',
            weight: 0,
        };
    };

    return (
        <EditableTable
            headers={headers}
            data={treatments}
            onDataChange={onTreatmentsChange}
            cellTemplates={cellTemplates}
            getNewRow={getNewRow}
            title="Tratos"
        />
    );
}
